export default __webpack_public_path__ + "static/media/LoginSuccess.5ff7fbff.png";